exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-icon {\r\n\twidth: 65px;\r\n}\r\n\r\n.option-card {\r\n\tmin-height: 145px;\r\n\tpadding: 10px 20px;\r\n\tbackground-color: white;\r\n\tborder: 1px solid #E2E7EB;\r\n}\r\n\r\n.option-card:hover {\r\n\tcursor: pointer;\r\n}\r\n\r\n.option-card-selected {\r\n\tcolor: white;\r\n\tbackground: rgb(41,201,171);\r\n\tbackground: linear-gradient(90deg, rgba(41,201,171,1) 0%, rgba(4,182,215,1) 100%);\r\n}\r\n\r\n.options-value {\r\n\tfont-weight: bold;\r\n}\r\n\r\n\r\n/*.item-menu {\r\n\tmax-height: 200px !important;\r\n\t/*background-color: #dcdcdc;*/\r\n/*\theight: 180px;\r\n}\r\n\r\n.item-menu-icon {\r\n\twidth: 90px !important;\t\r\n}\r\n\r\n.opcion-card {\r\n\tpadding: 0px !important;\r\n\tbackground-color: white;\r\n\tcursor: pointer;\r\n}\r\n\r\n.opcion-card-titulo {\r\n\tfont-weight: bold;\r\n\tmargin-top: 30px;\r\n\tcolor: #33a584;\r\n\ttext-align: left;\r\n}\r\n\r\n.opcion-card-descripcion {\r\n\tpadding: 0px 20px 15px 0px;\r\n\ttext-align: justify;\r\n}*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/components/menu/menu.component.css
// module id = ../../../../../src/app/modules/habilitar-cuenta/components/menu/menu.component.css
// module chunks = main